import React, { useState, useEffect } from "react";
import { BsDot } from "react-icons/bs";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
// import { RxDotFilled } from "react-icons/rx";

const DetailsSlider = ({ images, autoplay, h }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let interval = null;

    if (autoplay) {
      interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, autoplay);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autoplay, images.length]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const goToSlide = (slideIndex) => {
    setCurrentIndex(slideIndex);
  };

  return (
    <div
      className={`max-w-[1400px] h-[250px] md:h-[480px] w-full m-auto pt-5 relative group mb-10 transition-all duration-1000 bg-whites`}
    >
      <div
        style={{ backgroundImage: `url("${images[currentIndex].url}")` }}
        className="w-full h-full rounded-xl bg-center bg-contain bg-no-repeat duration-500"
      ></div>

      <div
        onClick={prevSlide}
        className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] left-5 text-2xl rounded-full p-2 bg-black/20 cursor-pointer"
      >
        <MdChevronLeft />
      </div>
      <div
        onClick={nextSlide}
        className="hidden group-hover:block absolute top-[50%] -translate-x-0 translate-y-[-50%] right-5 text-2xl rounded-full p-2 bg-black/20 cursor-pointer"
      >
        <MdChevronRight />
      </div>
      <div className="flex top-4 justify-center py-2">
        {images.map((_, slideIndex) => (
          <div
            key={slideIndex}
            onClick={() => goToSlide(slideIndex)}
            className={`${
              slideIndex === currentIndex ? "text-slate-400 " : ""
            } text-2xl cursor-pointer`}
          >
            <BsDot className="text-2xl lg:text-4xl font-bold" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailsSlider;
